function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Facilities'))  {
    return [
    {
      title: 'Facilities',
      icon: 'mdi-domain',
      items: [
        {
          icon: 'mdi-map-marker',
          title: 'set_rooms',
          path: '/SetRooms'
        },
        {
          icon: 'mdi-cannabis',
          title: 'set_strain',
          path: '/SetStrain'
        }
        
      ]
    }
  ]} else return []
}

export default buildMenu